import { useEffect, useState } from "react";

import Paper from "@mui/material/Paper";

function Global2025() {
  return (
    <div
      style={{
        margin: "auto",
        display: "flex",
        width: "90%",
        flexDirection: "column",
      }}
    >
      <Paper sx={{ width: "100%", overflow: "hidden", marginTop: "5px" }}>
        <img
          src={`${process.env.PUBLIC_URL}/images/landing_global.jpeg`}
          alt=""
        />
      </Paper>
    </div>
  );
}

export default Global2025;
